import { useState, useEffect, useRef } from "react";
import { AxiosError } from "axios";
import axiosInstance from "../shared/axiosInstance";

export const useGetService = (url?: string, skipFetch?: boolean) => {
  const [response, setResponse] = useState<any>();
  const [error, setError] = useState<AxiosError>();
  const [detailedError, setDetailedError] = useState<AxiosError>();
  const [isLoading, setIsLoading] = useState(false);

  // Ignore responses from superseded requests.
  const latestRequestId = useRef(0);

  const fetchData = async () => {
    const requestId = ++latestRequestId.current;
    setIsLoading(true);
    try {
      const result = await axiosInstance.get(
        process.env.REACT_APP_BASE_URL + "/" + url
      );
      if (requestId !== latestRequestId.current) return;
      setResponse(result.data);
      setError(undefined);
      setDetailedError(undefined);
    } catch (err: any) {
      if (requestId !== latestRequestId.current) return;
      setError(err?.message);
      setDetailedError(err);
    } finally {
      if (requestId === latestRequestId.current) setIsLoading(false);
    }
  };

  useEffect(() => {
    if (url && !skipFetch) {
      fetchData();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [url, skipFetch]);

  // Refetch data
  const refetch = async (updatedURL: string, silentFetch?: boolean) => {
    if (skipFetch) {
      return;
    }
    const requestId = ++latestRequestId.current;
    setIsLoading(!silentFetch);
    try {
      const result = await axiosInstance.get(
        process.env.REACT_APP_BASE_URL + "/" + updatedURL
      );
      if (requestId !== latestRequestId.current) return result;
      setResponse(result.data);
      setError(undefined);
      setDetailedError(undefined);
      return result;
    } catch (err: any) {
      if (requestId !== latestRequestId.current) return;
      setError(err?.message);
      setDetailedError(err);
      setResponse(undefined);
    } finally {
      if (requestId === latestRequestId.current) setIsLoading(false);
    }
  };

  const manualUpdateResp = (data: any) => {
    setResponse(data);
  }

  return { response, error, isLoading, refetch, detailedError, manualUpdateResp };
};
